module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIS ONE")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S FOR YOU")]), _vm._v(", R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGAN")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND FOR")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AIL")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARIS")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND FOR THE MEMBERS OF")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RINCESS OF")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWER")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LUB")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AY THEIR TIARAS TWINKLE ALL ACROSS THE LAND")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 60
// module chunks = 0